import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/qrCode_app.png")